import Base from "./Base";
import store from "../storeWire";
import {
    SET_CART_COUNT,
    SET_CART_DATA,
    SET_CART_PRODUCT_DATA,
    SET_CART_PRODUCT_INVENTORY_DATA,
    SET_CART_PRODUCT_PRICING_DATA,
    SET_CART_SHIPPING_ADDRESS_ID,
    SET_CLEAR_ALL_CART
} from "../store/slice/model/Cart";

class Cart extends Base {
    CART_COUNT = 0;
    CART_DATA = {};
    CART_SHIPPING_ADDRESS_ID = {};
    CART_PRODUCT_DATA = {};
    CART_PRODUCT_INVENTORY_DATA = {};

    setCartCount(data) {
        this.CART_COUNT = data.CART_COUNT;
        store.dispatch(SET_CART_COUNT({
            CART_COUNT: this.CART_COUNT
        }));
    }

    setCartData(data) {
        this.CART_DATA = data.CART_DATA;
        this.matchAllForCartData();
        store.dispatch(SET_CART_DATA({
            CART_DATA: this.CART_DATA
        }));
    }

    setCartShippingAddress(data) {
        this.CART_SHIPPING_ADDRESS_ID = data.CART_SHIPPING_ADDRESS_ID;
        store.dispatch(SET_CART_SHIPPING_ADDRESS_ID({
            CART_SHIPPING_ADDRESS_ID: this.CART_SHIPPING_ADDRESS_ID
        }));
    }

    setCartProductData(data) {
        this.CART_PRODUCT_DATA = data.CART_PRODUCT_DATA;
        store.dispatch(SET_CART_PRODUCT_DATA({
            CART_PRODUCT_DATA: this.CART_PRODUCT_DATA
        }));
    }

    setCartProductInventoryData(data) {
        this.CART_PRODUCT_INVENTORY_DATA = data.CART_PRODUCT_INVENTORY_DATA;
        store.dispatch(SET_CART_PRODUCT_INVENTORY_DATA({
            CART_PRODUCT_INVENTORY_DATA: this.CART_PRODUCT_INVENTORY_DATA
        }));
    }

    setCartProductPricingData(data) {
        this.CART_PRODUCT_PRICING_DATA = data.CART_PRODUCT_PRICING_DATA;
        store.dispatch(SET_CART_PRODUCT_PRICING_DATA({
            CART_PRODUCT_PRICING_DATA: this.CART_PRODUCT_PRICING_DATA
        }));

    }

    clearAllCart() {
        store.dispatch(SET_CLEAR_ALL_CART());
    }

    matchAllForCartData(data = false) {
        let dataHere = data;
        if (!dataHere) {
            dataHere = this.CART_DATA;
        }
        if (dataHere !== undefined && dataHere.length) {
            this.CART_DATA = dataHere.map((v) => {
                v.ERPPartNumber = v.partNumber;
                v.ManufacturerPartNumber = v.manufacturerPartNumber;
                v.ERPMFRPartNumber = v.erpMfrPartNumber;
                v.ItemNumber = v.itemNumber;
                v.backOrderQuantity = v.backOrderedQuantity;
                v.CUSTOMER_PART_NUMBER = v.cpn;
                if (v.isProductAvailableFromMainAPI === undefined) {
                    v.isProductAvailableFromMainAPI = true;
                }
                return v;
            })
        }
        return this.CART_DATA;
    }

    // manageOutOfSyncDisaster(cartFetchedProduct) {
    //     let state = store.getState();
    //     if (state.entities.Cart.CART_DATA) {
    //         let cartDetail = JSON.parse(JSON.stringify(state.entities.Cart.CART_DATA));
    //         ;
    //         let productCartOutOfSync = false;
    //         if (cartDetail.length > 0) {
    //             cartDetail.map((v, i) => {
    //                 if (cartFetchedProduct[v.partNumber] === undefined) {
    //                     v.isProductAvailableFromMainAPI = false;
    //                     cartDetail[i] = v;
    //                     productCartOutOfSync = true;
    //                 }
    //             });
    //             if (productCartOutOfSync) {
    //                 store.dispatch(SET_CART_DATA({
    //                     CART_DATA: cartDetail
    //                 }));
    //             }
    //         }
    //     }
    // }
}

export default Cart;